// extracted by mini-css-extract-plugin
module.exports = {"headTitle":"Description_headTitle__3x80H","mainText":"Description_mainText__2uGum","bottomText":"Description_bottomText__1bGgw"};